import React from 'react';
import { makeStyles } from '@mui/styles';
import { Collapse } from '@mui/material';
import Alert from '@mui/material/Alert';
import { AlertTitle } from '@mui/material';

const useStyles = makeStyles(() => ({
	spacingTop: { marginTop: '8px', marginBottom:'8px' },
}));

export default function AlertCollapse({ show, severity, title, text, className, id }) {
	const classes = useStyles();

	return (
		<Collapse timeout={1000} in={show} className={`${className} ${classes.spacingTop}`} id={id}>
			<Alert severity={severity || 'error'}>
				{title && <AlertTitle>{title}</AlertTitle>}
				{text}
			</Alert>
		</Collapse>
	);
}
